$(document).on('shown.bs.tab', 'a[data-toggle="tab"], a[data-toggle="pill"]', function (e) {
	CKEDITOR_Build(document);
});

// *******************************************************************
// HAPIDAM connector
// *******************************************************************

var HapidamUrl = null;
var HapidamClient = {};
window.HapidamClientBuilder = function (uuid = null) {
	uuid = uuid || ENV_HAPIDAM_UUID
	if (uuid && typeof HapidamClient[uuid] === 'undefined') {
		HapidamClient[uuid] = new Hapidam({ token: uuid, baseURL: ENV_HAPIDAM_BASE_URL });
		HapidamClient[uuid].on('select', function (result) {
			if (filemanagerFieldId !== null) {
				$('#' + filemanagerFieldId).val(JSON.stringify(result));
				$('#' + filemanagerFieldId).trigger('change');
			}
			HapidamClient[uuid].close();
		});
		// InitCKEditor return widget url
		HapidamUrl = HapidamClient[uuid].initCKEditor();
		console.info('HapidamClientBuilder:init');
	}
	if (uuid) {
		if (HapidamClient[uuid])
			return HapidamClient[uuid];
		else
			alert('Error! Unable to build Hapidam JS client instance');
	}
	return null;
}

// *******************************************************************

// RWD file manager
var fileManagerUrlForField = function (field_id) { return BASEPATH + 'assets/vendors/filemanager/dialog.php?HID=' + ENV_HID + '&popup=1&type=0&fldr=&field_id=' + field_id; }
var fileManagerUrlstandalone = function () { return BASEPATH + 'assets/vendors/filemanager/dialog.php?HID=' + ENV_HID + '&popup=1&type=0&fldr='; } // rwdFileManager

// Hybrid RWDF / HAPIDAM
var fileManagerUrlCkeditor = function (resourceType = "Files", uuid = null) {
	if (ENV_HAPIDAM_UUID) {
		HapidamClientBuilder(uuid);
		if (HapidamUrl)
			return HapidamUrl;
		else
			alert('Error! Unable to retrieve Hapidam connector URL');
	}
	else {
		return BASEPATH + 'assets/vendors/filemanager/dialog.php?HID=' + ENV_HID + '&type=2&fldr=&editor=ckeditor';
	}
}

// *******************************************************************

var filemanagerPopup = null;
var filemanagerFieldId = null;
// callback pour le rwdFilemanager
window.responsive_filemanager_callback = function (field_id) {
	$('#' + field_id).parent().find('button').removeClass('btn-primary').addClass('btn-success');
	$('#' + field_id).trigger('change');
}

window.HAPIDAM_REQUEST_BUILDER = function (field_id, resourceType, uuid = null) {
	filemanagerFieldId = (field_id ? field_id : 'null').replace('#', '');
	var dam = HapidamClientBuilder(uuid);
	if (dam !== null) {
		dam.openBuilder($('#' + filemanagerFieldId).val());
	}
}

window.FILEMANAGER_OPEN_FOR_FIELD = function (field_id, param, uuid = null) {
	param = param || {};

	var resourceType = typeof param == 'string' ? param : param.resourceType || 'Images'
	var multiple = param.multiple || false
	var limit = param.limit || 1

	filemanagerFieldId = (field_id ? field_id : 'null').replace('#', '');

	var dam = HapidamClientBuilder(uuid);
	if (dam !== null) {
		if (multiple) {
			dam.open({
				//switched: 'on', // can switch widget classic to wiget with request builder
				limit, // limit maximum of assets for the request
				multiple // ative multiple selection in classic widget
			});
		}
		else {
			dam.open();
		}
	}
	else {
		var W = window.screen.availWidth;
		var H = window.screen.availHeight;
		if (filemanagerPopup !== null)
			filemanagerPopup.close();
		filemanagerPopup = window.open(fileManagerUrlForField(filemanagerFieldId, resourceType), 'filemanager_popup', 'width=' + (W * .8) + ', height=' + (H * .8) + ', top=' + (H * .1) + ', left=' + (W * .1) + '');
	}
}

window.FILEMANAGER_OPEN_STANDALONE = function (resourceType, uuid = null) {
	filemanagerFieldId = null;

	var dam = HapidamClientBuilder(uuid);
	if (dam !== null) {
		dam.open();
	}
	else {
		var W = window.screen.availWidth;
		var H = window.screen.availHeight;
		if (filemanagerPopup !== null)
			filemanagerPopup.close();
		filemanagerPopup = window.open(fileManagerUrlstandalone(), 'filemanager_popup', 'width=' + (W * .8) + ', height=' + (H * .8) + ', top=' + (H * .1) + ', left=' + (W * .1) + '');
	}
}

// retire la class de marquage et détruit les instances de CKeditor de la zone ciblée
window.CKEDITOR_Destroy = function (selector) {
	$(selector).find('.wysiwyg, .wysiwyg-full, .wysiwyg-lite').removeClass('wysiwyg-ready').each(function () {
		var tagId = $(this).attr('id');
		if (CKEDITOR.instances[tagId])
			CKEDITOR.instances[tagId].destroy();
	});
}

window.CKEDITOR_Build = function (selector) {
	// force refresh for all code mirror field
	$('.CodeMirror').each(function (i, el) {
		el.CodeMirror.refresh();
	});

	var myStyleSet = [
		{ name: 'Default', element: 'p', attributes: { 'class': '' } },
		{ name: 'A.button', element: 'a', attributes: { 'class': 'button' } },
		{ name: 'A.button2', element: 'a', attributes: { 'class': 'button2' } },
		{ name: 'A.button3', element: 'a', attributes: { 'class': 'button3' } },
		{ name: 'A.button4', element: 'a', attributes: { 'class': 'button4' } },
		{ name: 'P.surtitre', element: 'p', attributes: { 'class': 'surtitre' } },
		{ name: 'P.h1', element: 'p', attributes: { 'class': 'h1' } },
		{ name: 'P.h2', element: 'p', attributes: { 'class': 'h2' } },
		{ name: 'P.h3', element: 'p', attributes: { 'class': 'h3' } },
		{ name: 'P.h4', element: 'p', attributes: { 'class': 'h4' } },
		{ name: 'Table[responsive]', element: 'table', attributes: { 'data-responsive': 'true' } },
		{ name: 'Scroll(A)', element: 'a', attributes: { 'data-scrolldown': 'true' } },
		{ name: 'Scroll(P)', element: 'p', attributes: { 'data-scrolldown': 'true' } },
		{ name: 'Scroll(SPAN)', element: 'span', attributes: { 'data-scrolldown': 'true' } },
		{ name: 'NoResize', element: 'img', attributes: { 'class': 'noresize' } },
	];

	if (window.CKEDITOR_CUSTOM_STYLESET && window.CKEDITOR_CUSTOM_STYLESET.length > 0) {
		for (let i = 0; i < window.CKEDITOR_CUSTOM_STYLESET.length; i++)
			myStyleSet.push(window.CKEDITOR_CUSTOM_STYLESET[i]);
	}

	var custom_ckeditor_buttons = [
		{
			name: 'button1',
			icon: '../_htmlbuttons_icons/button.png',
			html: '<a href="#" class="button">Lorem impsum</a>',
			title: 'Button style 1'
		},
		{
			name: 'button2',
			icon: '../_htmlbuttons_icons/button2.png',
			html: '<a href="#" class="button2">Lorem impsum</a>',
			title: 'Button style 2'
		},
		{
			name: 'button3',
			icon: '../_htmlbuttons_icons/button3.png',
			html: '<a href="#" class="button3">Lorem impsum</a>',
			title: 'Button style 3'
		},
		{
			name: 'button4',
			icon: '../_htmlbuttons_icons/button4.png',
			html: '<a href="#" class="button4">Lorem impsum</a>',
			title: 'Button style 4'
		},
		{
			name: 'scrolldown',
			icon: '../_htmlbuttons_icons/scrolldown.png',
			html: '<a href="#" data-scrolldown="true">Lorem impsum</a>',
			title: 'Automatic scrollDown'
		},
		{
			name: 'separateur',
			icon: '../_htmlbuttons_icons/separator.png',
			html: '<hr class="separateur" />',
			title: 'Séparateur ligne simple'
		},
		{
			name: 'separateur2',
			icon: '../_htmlbuttons_icons/separator2.png',
			html: '<hr class="separateur2" />',
			title: 'Séparateur en pointillés'
		}
	];

	var allowedTags = [
		'a',
		'button',
		'h1',
		'h2',
		'h3',
		'h4',
		'h5',
		'h6',
		'p',
		'ol',
		'ul',
		'li',
		'dl',
		'dt',
		'dd',
		'span',
		'em',
		'i',
		'b',
		'strong',
		'style',
		'script',
		'iframe',
		'u',
		's',
		'strike',
		'small',
		'sup',
		'sub',
		'blockquote',
		'div',
		'table',
		'tr',
		'th',
		'td',
		'thead',
		'tfoot',
		'svg',
		'img',
		'video',
		'media',
		'embed',
		'br',
		'hr',
		'link',
		'form',
		'input',
		'textarea',
		'select',
		'option',
		'pre', 'code'
	];
	var allowedContent = [];
	for (var i = 0; i < allowedTags.length; i++) {
		var tag = allowedTags[i];
		allowedContent.push(tag + '(*){*}[*]');
	}
	allowedContent = allowedContent.join(';');

	var iframe_attributes = function (iframe) {
		if (iframe.attributes.src.match(/(https?:\/\/)?(www\.?)(youtube\.com|sample.com)/)) {
			return { sandbox: "allow-scripts allow-same-origin" }
		}
		else {
			return { sandbox: "allow-scripts allow-same-origin" }
		}
	}

	var custom_ckeditor_colorButton_colors = window.custom_ckeditor_colorButton_colors || null;

	CKEDITOR._.HapiQuicklinkDialog = CKEDITOR._.HapiQuicklinkDialog || {};
	CKEDITOR._.HapiQuicklinkDialog.autocompleteURL = BASEPATH + '/admin/HID' + ENV_HID + '/ajax/hapi_quicklink';

	// WYSIWYG DEFAULT -------------------------------------------------------------------------------------
	var ckeditorConfig = {
		//bodyClass: 'hapiTypo',
		skin: 'moono-lisa',
		language: 'en',
		customConfig: '',
		contentsCss: CKEDITOR_CSS,
		fontAwesome_version: '5.0',
		scayt_autoStartup: false,
		resize_enabled: false,

		extraPlugins: 'pastefromword,texttransform,codemirror,colorbutton,font,iframe,find,selectall,pagebreak,div,codesnippet,justify,autogrow,widget,lineutils,colordialog,htmlbuttons,richcombo,letterspacing,police,effect,fontawesome,sc_services,sc_countdown,hapi_quicklink',
		autoGrow_onStartup: true,
		autoGrow_minHeight: 200,
		autoGrow_maxHeight: window.screen.availHeight * 0.5,
		removePlugins: 'resize',

		allowedContent: allowedContent,
		iframe_attributes: iframe_attributes,

		filebrowserBrowseUrl: fileManagerUrlCkeditor(),
		filebrowserFlashBrowseUrl: fileManagerUrlCkeditor(),
		filebrowserImageBrowseUrl: fileManagerUrlCkeditor("Images"),
		filebrowserUploadUrl: false,
		filebrowserImageUploadUrl: false,
		filebrowserFlashUploadUrl: false,

		codemirror: {
			// Set this to the theme you wish to use (codemirror themes)
			theme: 'monokai',
			// Whether or not you want to show line numbers
			lineNumbers: true,
			// Whether or not you want to use line wrapping
			lineWrapping: true,
			// Whether or not you want to highlight matching braces
			matchBrackets: true,
			// Whether or not you want tags to automatically close themselves
			autoCloseTags: true,
			// Whether or not you want Brackets to automatically close themselves
			autoCloseBrackets: true,
			// Whether or not to enable search tools, CTRL+F (Find), CTRL+SHIFT+F (Replace), CTRL+SHIFT+R (Replace All), CTRL+G (Find Next), CTRL+SHIFT+G (Find Previous)
			enableSearchTools: true,
			// Whether or not you wish to enable code folding (requires 'lineNumbers' to be set to 'true')
			enableCodeFolding: true,
			// Whether or not to enable code formatting
			enableCodeFormatting: true,
			// Whether or not to automatically format code should be done when the editor is loaded
			autoFormatOnStart: true,
			// Whether or not to automatically format code should be done every time the source view is opened
			autoFormatOnModeChange: true,
			// Whether or not to automatically format code which has just been uncommented
			autoFormatOnUncomment: true,
			// Define the language specific mode 'htmlmixed' for html including (css, xml, javascript), 'application/x-httpd-php' for php mode including html, or 'text/javascript' for using java script only
			mode: 'htmlmixed',
			// Whether or not to show the search Code button on the toolbar
			showSearchButton: true,
			// Whether or not to show Trailing Spaces
			showTrailingSpace: true,
			// Whether or not to highlight all matches of current word/selection
			highlightMatches: true,
			// Whether or not to show the format button on the toolbar
			showFormatButton: true,
			// Whether or not to show the comment button on the toolbar
			showCommentButton: true,
			// Whether or not to show the uncomment button on the toolbar
			showUncommentButton: true,
			// Whether or not to show the showAutoCompleteButton button on the toolbar
			showAutoCompleteButton: true,
			// Whether or not to highlight the currently active line
			styleActiveLine: true
		},

		wordcount: {
			showWordCount: true,
			showCharCount: true
		},

		htmlbuttons: custom_ckeditor_buttons,

		toolbar: [
			{ name: 'document', items: ['Maximize', 'Source', 'ShowBlocks'] },
			{ name: 'clipboard', items: ['PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
			{ name: 'links', items: ['Link', 'HapiQuicklink', 'Unlink', 'Anchor'] },
			{ name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll'] },
			{ name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat'] },
			{ name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', 'CodeSnippet'] },
			{ name: 'paragraph_2', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
			{ name: 'insert', items: ['oembed', 'Image', 'Iframe', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
			{ name: 'Format', items: ['Format', 'Styles', 'police'] },
			{ name: 'styles1', items: ['TextColor', 'FontAwesome'] },
			{ name: 'texttransform', items: ['TransformTextToUppercase', 'TransformTextToLowercase', 'TransformTextCapitalize', 'TransformTextSwitcher'] },
			//{ name: 'letterspacing',     items : [ 'letterspacing' ] },
			//{ name: 'Effet',     items : [ 'effect' ] },
			{ name: 'styles5', items: ['ScServices', 'ScCountdown', 'button1', 'button2', 'button3', 'button4', 'scrolldown', 'separateur', 'separateur2'] }
		],
		stylesSet: myStyleSet,
	};

	if (custom_ckeditor_colorButton_colors !== null)
		ckeditorConfig.colorButton_colors = custom_ckeditor_colorButton_colors;

	$(selector).find('.wysiwyg')
		.filter(':visible')
		.not('.wysiwyg-ready')
		.addClass('wysiwyg-ready')
		.each(function (e) {
			var config = {};
			$.extend(config, ckeditorConfig, { height: $(this).height() });
			if ($(this).hasClass('no_autogrow'))
				$.extend(config, { autoGrow_maxHeight: 400 });
			CKEDITOR.dtd.$removeEmpty.i = false;
			CKEDITOR.dtd.$removeEmpty.span = false;

			var editor = CKEDITOR.replace(this, config);
			editor.on('change', function (event) {
				event.editor.updateElement(); $(event.editor.element.$).trigger('change');
			})

			setTimeout(function (editor) {
				var $cke_contents = $('#cke_' + editor.name + ' .cke_contents iframe');
				if ($(this).attr('style').match('background'))
					$cke_contents[0].style.setProperty('background', $(this).css('background'), 'important');
			}.bind(this, editor), 1500);
		});

	// WYSIWYG LITE -------------------------------------------------------------------------------------
	var ckeditorLiteConfig = {
		skin: 'moono-lisa',
		language: 'en',
		contentsCss: CKEDITOR_CSS,
		fontAwesome_version: '5.0',
		scayt_autoStartup: false,
		resize_enabled: false,

		extraPlugins: 'pastefromword,justify,autogrow,lineutils,widget,colordialog,fontawesome,htmlbuttons,richcombo,letterspacing',
		autoGrow_onStartup: true,
		autoGrow_minHeight: 100,
		autoGrow_maxHeight: 750,
		removePlugins: 'resize',

		allowedContent: allowedContent,
		iframe_attributes: iframe_attributes,

		filebrowserBrowseUrl: fileManagerUrlCkeditor(),
		filebrowserFlashBrowseUrl: fileManagerUrlCkeditor(),
		filebrowserImageBrowseUrl: fileManagerUrlCkeditor("Images"),
		filebrowserUploadUrl: false,
		filebrowserImageUploadUrl: false,
		filebrowserFlashUploadUrl: false,

		wordcount: {
			showWordCount: true,
			showCharCount: true
		},

		htmlbuttons: custom_ckeditor_buttons,


		toolbar: [
			{ name: 'document', items: ['Maximize', 'Source', 'ShowBlocks'] },
			{ name: 'links', items: ['Link', 'Unlink'] },
			{ name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] },
			{ name: 'paragraph2', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
			{ name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
			{ name: 'styles5', items: ['letterspacing'] },
			{ name: 'Format', items: ['Format'] }
		],
		stylesSet: myStyleSet,
	};

	if (custom_ckeditor_colorButton_colors !== null)
		ckeditorLiteConfig.colorButton_colors = custom_ckeditor_colorButton_colors;

	$(selector).find('.wysiwyg-lite')
		.filter(':visible')
		.not('.wysiwyg-ready')
		.addClass('wysiwyg-ready')
		.each(function () {
			var config = {};
			$.extend(config, ckeditorLiteConfig, { height: $(this).height() });
			if ($(this).hasClass('no_autogrow'))
				$.extend(config, { autoGrow_maxHeight: 400 });
			CKEDITOR.dtd.$removeEmpty.i = false;
			CKEDITOR.dtd.$removeEmpty.span = false;
			var editor = CKEDITOR.replace(this, config);

			editor.on('change', function (event) {
				event.editor.updateElement(); $(event.editor.element.$).trigger('change');
			})

			setTimeout(function (editor) {
				var $cke_contents = $('#cke_' + editor.name + ' .cke_contents iframe');
				if ($(this).attr('style').match('background'))
					$cke_contents[0].style.setProperty('background', $(this).css('background'), 'important');
			}.bind(this, editor), 1500);
		});
}
